/**
 * Front-end JavaScript
 *
 * The JavaScript code you place here will be processed by esbuild. The output
 * file will be created at `../theme/js/script.min.js` and enqueued in
 * `../theme/functions.php`.
 *
 * For esbuild documentation, please see:
 * https://esbuild.github.io/
 */
import { createApp } from 'vue';
import { createPinia } from 'pinia';

import 'primeicons/primeicons.css';
import './navigation';
import Control from './components/navbar/Control.vue';
import Game from './pages/Game.vue';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import Download from './components/banner/Download.vue';
import Mobile from './components/navbar/Mobile.vue';
import App from './pages/App.vue';
import IndexSubMenu from './components/navbar/IndexSubMenu.vue';
import { showVuePopup } from './utils/showVuePopup';
import Register from './popup/Register.vue';
import Lotto from './pages/Lotto.vue';
import Sport from './pages/Sport.vue';
import Recommended from './pages/Recommended.vue';
import CarouselGame1 from './components/CarouselGame1.vue';
import CarouselGame2 from './components/CarouselGame2.vue';

const pinia = createPinia();

const isHomePage = (): boolean => {
	const path = window.location.pathname;
	return path === '/' || path.endsWith('/index.html');
};

document.addEventListener('DOMContentLoaded', async () => {
	try {
		if (!isHomePage()) return;

		const params = new URLSearchParams(window.location.search);

		const action = (params.get('action') ?? '').trim().toLowerCase();
		const refMk  = (params.get('marketingRef') ?? '').trim().toLowerCase();
		const refAf  = (params.get('ref') ?? '').trim().toLowerCase();

		const hasAnyRef = refMk !== '' || refAf !== '';

		if (action === 'register' && hasAnyRef) {
			await showVuePopup(
				Register,
				{ options: { marketingRefId: refMk, affiliationRefId: refAf } },
				{}
			);

		}
	} catch (err) {
		console.error('open register popup failed:', err);
	}
});

/**
 * App
 */
const elApp = document.getElementById('app')
if (elApp) {
	const app = createApp(App, {});
	app.use(pinia);
	app.use(PrimeVue, {
		theme: {
			preset: Aura,
			options: {
				darkModeSelector: false,
			},
		},
	})
	app.use(ToastService)
	app.component('Toast', Toast);
	app.mount('#app');
}

/**
 * IndexSubMenu
 */
const elIndexSubMenu = document.getElementById('index-sub-menu');
if (elIndexSubMenu) {
	const app = createApp(IndexSubMenu, {});
	app.use(pinia);
	app.use(PrimeVue, {
		theme: {
			preset: Aura,
			options: {
				darkModeSelector: false,
			},
		},
	})
	app.use(ToastService)
	app.component('Toast', Toast);
	app.mount('#index-sub-menu');
}

/**
 * Banner Download
 */
const elBanner = document.getElementById('banner-download')
if (elBanner) {
	const app = createApp(Download, {});
	app.use(pinia);
	app.use(PrimeVue, {
		theme: {
			preset: Aura,
			options: {
				darkModeSelector: false,
			},
		},
	})
	app.use(ToastService)
	app.component('Toast', Toast);
	app.mount('#banner-download');
}

/**
 * Carousel 1
 */
const elCarousel1 = document.getElementById('carousel-game-1')
if (elCarousel1) {
	const app = createApp(CarouselGame1, {});
	app.use(pinia);
	app.use(PrimeVue, {
		theme: {
			preset: Aura,
			options: {
				darkModeSelector: false,
			},
		},
	})
	app.use(ToastService)
	app.component('Toast', Toast);
	app.mount('#carousel-game-1');
}

/**
 * Carousel 2
 */
const elCarousel2 = document.getElementById('carousel-game-2')
if (elCarousel2) {
	const app = createApp(CarouselGame2, {});
	app.use(pinia);
	app.use(PrimeVue, {
		theme: {
			preset: Aura,
			options: {
				darkModeSelector: false,
			},
		},
	})
	app.use(ToastService)
	app.component('Toast', Toast);
	app.mount('#carousel-game-2');
}

/**
 * Control
 */
const elControl = document.getElementById('control')
if (elControl) {
	const app = createApp(Control, {});
	app.use(pinia);
	app.use(PrimeVue, {
		theme: {
			preset: Aura,
			options: {
				darkModeSelector: false,
			},
		},
	})
	app.use(ToastService)
	app.component('Toast', Toast);
	app.mount('#control');
}

/**
 * Mobile
 */
const elMobile = document.getElementById('mobile-navbar')
if (elMobile) {
	const app = createApp(Mobile, {});
	app.use(pinia);
	app.use(PrimeVue, {
		theme: {
			preset: Aura,
			options: {
				darkModeSelector: false,
			},
		},
	})
	app.use(ToastService)
	app.component('Toast', Toast);
	app.mount('#mobile-navbar');
}

/**
 * Game
 */
const elGame = document.getElementById('game')
if (elGame) {
	const gameType = elGame.getAttribute('game-type') || '';
	const app = createApp(Game, {gameType: gameType});
	app.use(pinia);
	app.use(PrimeVue, {
		theme: {
			preset: Aura,
			options: {
				darkModeSelector: false,
			},
		},
	})
	app.use(ToastService)
	app.component('Toast', Toast);
	app.mount('#game');
}

/**
 * Lotto
 */
const elLotto = document.getElementById('lotto')
if (elLotto) {
	const gameType = elLotto.getAttribute('game-type') || '';
	const app = createApp(Lotto, {gameType: gameType});
	app.use(pinia);
	app.use(PrimeVue, {
		theme: {
			preset: Aura,
			options: {
				darkModeSelector: false,
			},
		},
	})
	app.use(ToastService)
	app.component('Toast', Toast);
	app.mount('#lotto');
}

/**
 * Sport
 */
const elSport = document.getElementById('sport')
if (elSport) {
	const gameType = elSport.getAttribute('game-type') || '';
	const app = createApp(Sport, {gameType: gameType});
	app.use(pinia);
	app.use(PrimeVue, {
		theme: {
			preset: Aura,
			options: {
				darkModeSelector: false,
			},
		},
	})
	app.use(ToastService)
	app.component('Toast', Toast);
	app.mount('#sport');
}

/**
 * Recommended
 */
const elRecommended = document.getElementById('recommended')
if (elRecommended) {
	const gameType = elRecommended.getAttribute('game-type') || '';
	const app = createApp(Recommended, {gameType: gameType});
	app.use(pinia);
	app.use(PrimeVue, {
		theme: {
			preset: Aura,
			options: {
				darkModeSelector: false,
			},
		},
	})
	app.use(ToastService)
	app.component('Toast', Toast);
	app.mount('#recommended');
}
